import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationMain } from '../../styles/common'
import LoaderComponent from 'src/components/common/loader.component';
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem, Input } from '@material-ui/core';
import { getCountries, setCountry } from '../../actions/action.userAuth';
import { AssignCountryWrapper } from 'src/styles/assigncountry';
import { assignCountryToUserCall } from '../../effects/api/api.common';
import { push } from 'connected-react-router';
import { getLocalStorageValue, clearLocalStorageValueForKey, setLocalStorageValue } from 'src/effects/utils/local-storage';

class CountryAssignment extends React.Component<any, any> {
    state = {
        countryId: 0
    };

    constructor(props: any) {
        super(props);

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.saveCountry = this.saveCountry.bind(this);
    }

    saveCountry = () => {
        assignCountryToUserCall(this.state.countryId).then((res: any) => {
            if (res.status === 200) {
                const localStorageuserData = getLocalStorageValue('user');
                localStorageuserData.activeCountryId = this.state.countryId;
                clearLocalStorageValueForKey('user');
                setLocalStorageValue('user', JSON.stringify(localStorageuserData))
                this.props.redirectTo("/surveyreports");
                this.props.setCountry();
            }
        })

    }

    handleCountryChange = (event: any) => {
        this.setState({ countryId: event.target.value });
    }

    async componentDidMount() {
        this.props.getCountries()
    }

    render() {
        return (
            <>
                <ApplicationMain>
                    <LoaderComponent sending={this.props.show} />

                    <AssignCountryWrapper>
                        <div className="pageContainer profileScreen">
                            <div className="pageHeading">
                                <Grid container={true} spacing={8}>
                                    <Grid item={true} xs={6}>
                                        <div className="pageTitleSection">

                                            <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                                Country Assignment
                                    </Typography>

                                        </div>
                                    </Grid>

                                    <Grid item={true} xs={6}>

                                        <div className="pagesLinks text-right">
                                            {
                                                <ul>
                                                    <li className="listItem" >
                                                        <a href="javascript:void(0)" className="primary" onClick={this.saveCountry}>Save</a>
                                                    </li>

                                                </ul>

                                            }
                                        </div>

                                    </Grid>
                                </Grid>
                            </div>

                            <div className="pageContent">
                                <div className="contentSection">

                                    <Grid container={true} spacing={8} alignItems={"center"}>
                                        <Grid item={true} xs={6}>
                                            <FormControl fullWidth={true} className="formControl">
                                                <InputLabel htmlFor="country">Country</InputLabel>
                                                <Select
                                                    value={this.state.countryId}
                                                    onChange={this.handleCountryChange}
                                                    input={<Input name="country" id="age-auto-width" />}
                                                    autoWidth={false}
                                                    className="inputControl"
                                                >
                                                    <MenuItem key={0} value={0}>Select</MenuItem>
                                                    {this.props.countries.map((mt: any) => {
                                                        return (
                                                            <MenuItem key={mt.id} value={mt.id}>{mt.name}</MenuItem>
                                                        )
                                                    })
                                                    }
                                                </Select>

                                            </FormControl>

                                        </Grid>
                                    </Grid>

                                </div>
                            </div>

                        </div>

                    </AssignCountryWrapper>

                </ApplicationMain>
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        countries: state.user.countries
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (path: string) => dispatch(push(path)),
        getCountries: () => dispatch(getCountries()),
        setCountry: () => dispatch(setCountry())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryAssignment);



// WEBPACK FOOTER //
// ./src/components/login/profile.tsx